module.exports = __webpack_public_path__ + "static/product-pc-content-1-03eb3033b2110e3c26df551810aa0f28.jpg";